import * as React from 'react';

const Icon = (props:any) => (
    <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M0 0h64v64H0z" />
            <path
                d="M32 13c10.493 0 19 8.507 19 19s-8.507 19-19 19-19-8.507-19-19 8.507-19 19-19zm-3 17v12h6V30h-6zm0-9v6h6v-6h-6z"
                fill="#7B838C" />
        </g>
    </svg>
);

export default Icon;

